import { ModalProps, ModalService } from '@philips-internal/oswald-ui-components';
import { ModalButtonType } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { TasyRescheduleParameters } from '../interfaces/tasy-parameters';
import { ScheduleParameters } from 'src/interfaces/schedule-parameters';
import { RescheduleCheckup } from '../interfaces/reschedule-checkup';

class RescheduleContext {
  static nrSeqAgeint: number;
  static hasInsuranceSelected: boolean;
  static rescheduleCheckup: RescheduleCheckup;
  static rescheduleParameters: TasyRescheduleParameters;
  static scheduleParameters: ScheduleParameters;
}

export const rescheduleCancelModal: ModalProps = {
  closeable: false,
  closeByDocument: false,
  closeByEscape: false,
  dialogDescription: MessageService.translate('patient.cancel-reschedule'),
  dockButtons: [
    {
      action: (): void => void {},
      title: MessageService.translate('patient.cancel'),
      type: ModalButtonType.CANCEL
    },
    {
      action: (): void => {
        ModalService.close('reschedule-transference-modal');
        RescheduleContext.hasInsuranceSelected = false;
      },
      title: MessageService.translate('patient.confirm'),
      type: ModalButtonType.SUCCESS
    }
  ],
  focusOnOpen: true,
  title: MessageService.translate('patient.cancel-reschedule-confirmation'),
  uuid: generateUUID(),
};

export default RescheduleContext;
